export class Annotation {
    textStyle?: any;
    stemColor?: string;
    alwaysOutside?: boolean;
}